<template>
    <div class="page-box">
      <Header/>
      <div class="page-content bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" :title2="title2" :title-row1="titleRow1" :title-row2="titleRow2" :blue-text="blueText" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '166px'}" />
      </div>
      <ModuleTitle data-aos="fade-up" bg-color="#fff" title="经营痛点" :moduleTipsList="moduleTipsList" />
      <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <CardItem v-for="(item, index) in painList" :key="index" :item="item"></CardItem>
          </div>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="业务特征" :moduleTipsList="[{name: '链接品牌商、经销商、批发商，实现产业链各端信息共享与协同，全流程业务闭环'}]" />
          <img class="showImg" data-aos="fade-up" :src="BusinessCharacteristicsImg" alt="" />
      </ModuleCenter>
      <!-- 核心优势 -->
      <div class="mg-btm-70 bg-color-0B4FD1">
        <ModuleBgBlue >
          <ModuleCenter >
            <div class="core-advantages">
              <ModuleTitle data-aos="fade-up" title="核心优势" :title-stype="ModuleTitleStype" title-color="#fff" :desc-stype="titleDescStype" :moduleTipsList="[{name: '融合传统线下交易特点，应用数字化手段，提升运营效率'}]" />
              <div class="flex-box" data-aos="fade-up" >
                <CardItem v-for="(item, index) in advantageList" :key="index" :item="item" :card-style="advantageCardStyle"></CardItem>
              </div>
            </div>
          </ModuleCenter>
        </ModuleBgBlue>
      </div>
      <!-- 全链路赋能，全面增效 -->
      <div class="mg-btm-40">
        <ModuleCenter >
          <ModuleTitle data-aos="fade-up"  title="全链路赋能，全面增效" :title-stype="{ marginBottom: '55px'}" />
          <DSUpModule data-aos="fade-up" />
        </ModuleCenter>
      </div>
      <!-- 多模式支持，适应不同经营要求 -->
      <div class="multi-mode center-box bg-color-F4F5FB">
        <div class="max-width-1920" style="background-color: #F4F5FB;">
          <ModuleTitle data-aos="fade-up" title="多模式支持，适应不同经营要求" :moduleTipsList="[{name: '针对自身业务特点和产业链定位，系统支持自营模式、POP模式、品牌直营模式'}]" />
          <ModuleCenter>
            <div class="flex-box" data-aos="fade-up">
              <div class="multi-mode-item">
                <img class="multi-mode-item-img" src="@/assets/product/digitalSystem/multi-mode-1.png" />
                <div class="multi-mode-item-title">自营模式</div>
                <div class="multi-mode-item-desc">面向经销商对自建渠道的经营，采、销自主可控，实现高标准的私域运营与数字化的业务闭环。</div>
               
              </div>
              <div class="multi-mode-item">
                <img class="multi-mode-item-img" src="@/assets/product/digitalSystem/multi-mode-2.png" />
                <div class="multi-mode-item-title">POP模式</div>
                <div class="multi-mode-item-desc">打造开放的交易平台，吸引优质供应商、服务商、客户入驻，通过不断强化平台服务标准和体验来提升客户交易粘性，由此实现正向的驱动增长。</div>
                
              </div>
              <div class="multi-mode-item">
                <img class="multi-mode-item-img" src="@/assets/product/digitalSystem/multi-mode-3.png" />
                <div class="multi-mode-item-title">品牌直销模式</div>
                <div class="multi-mode-item-desc">品牌商通过数字化赋能全价值链，直接服务门店终端，以数据驱动决策用户需求驱动生产，实现生产的柔性化、经营的智能化。</div>
                
              </div>
            </div>
          </ModuleCenter>
        </div>
      </div>
      <!-- 商品管理 -->
      <div class="goods-manage">
        <ModuleTitle data-aos="fade-up" title="商品管理"  :moduleTipsList="[{name: '实现商品多维度统一管理，构建商品体系数字化运营'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">商品库存统一管理</span>
                  <div>商品库存共享、灵活分配，全渠道一盘货管</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">销售区域配置</span>
                  <div>针对不同商品、不同分类可设置不同的销售区域</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">多终端数据共享</span>
                  <div>PC、APP、H5、小程序多终端共享一个商品库数据</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" src="@/assets/product/digitalSystem/goods-manage-mid.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">灵活的商品定义</span>
                  <div>支持标品、组合商品、包装辅材、工业品等</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">渠道差异化覆盖</span>
                  <div>针对销售渠道不同，差异化产品覆盖、差异化价格策略</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">灵活的商品规格配置</span>
                  <div>适应不同商品特征，结合库存、交期等灵活配置</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 多种价格策略 -->
      <div class="multi-price-strategy center-box bg-color-F4F5FB">
        <div class="max-width-1920" style="background-color: #F4F5FB;">
          <div style="maring-bottom: 60px;">
            <ModuleTitle data-aos="fade-up" title="多种价格策略" :moduleTipsList="[{name: '支持特殊商品、不同会员的差异化定价'}]" />
          </div>
          <ModuleCenter>
            <div class="multi-price-strategy-flex" data-aos="fade-up">
              <img class="img" src="@/assets/product/digitalSystem/price-strategy.png" alt="">
              <div class="multi-price-strategy-content">
                <div class="multi-price-strategy-item">
                  <div class="multi-price-strategy-title">差异化的价格策略</div>
                  <div class="multi-price-strategy-desc">
                    <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                    <div class="multi-price-strategy-desc-text">商品基础价、阶梯价、区域价格，采购商等级价格，客户一客一价</div>
                  </div>
                </div>
                <div class="multi-price-strategy-item">
                  <div class="multi-price-strategy-title">快速选品生成报价单</div>
                  <div class="multi-price-strategy-desc">
                    <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                    <div class="multi-price-strategy-desc-text">快速选品，定义报价表格式、参数</div>
                  </div>
                  <div class="multi-price-strategy-desc">
                    <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                    <div class="multi-price-strategy-desc-text">生成报价单后支持导出、打印</div>
                  </div>
                  <div class="multi-price-strategy-desc">
                    <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                    <div class="multi-price-strategy-desc-text">报价单周期锁定价格，方便内部流程审批</div>
                  </div>
                  <div class="multi-price-strategy-desc">
                    <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                    <div class="multi-price-strategy-desc-text">报价单一键转订单</div>
                  </div>
                </div>
              </div>
            </div>
          </ModuleCenter>
        </div>
      </div>
      <!-- 配额/配提灵活应用，促活跃去库存 -->
      <div class="activity-box">
        <div style="margin-bottom: 80px;">
          <ModuleTitle data-aos="fade-up" title="配额/配提灵活应用，促活跃去库存" :moduleTipsList="[{name: '通过调控用户的购买行为，头部商品高效带动其他品类交易，实现平台的活跃、销售增长和库存平衡等目标'}]" />
        </div>
        <ModuleCenter>
          <div class="activity-content" data-aos="fade-up">
            <div class="activity-content-item">
              <div class="activity-content-left mg-right-115">
                <div class="title">促活跃，商品配额 按额度配比购买促活跃</div>
                <div class="multi-price-strategy-desc">
                  <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                  <div class="multi-price-strategy-desc-text" style="width: auto;">品牌商或代理商可对下级客户进行分类分群</div>
                </div>
                <div class="multi-price-strategy-desc">
                  <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                  <div class="multi-price-strategy-desc-text" style="width: auto;">对于稀缺商品，可自由配置各客户群体的购买额度，提高客户活跃度</div>
                </div>
                <div class="multi-price-strategy-desc">
                  <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                  <div class="multi-price-strategy-desc-text" style="width: auto;">客户额度实时统计跟踪，可配置额度有效期</div>
                </div>
              </div>
              <img class="activity-img" src="@/assets/product/digitalSystem/activity-banner-1.png" alt="">
            </div>
            <div class="activity-content-item">
              <img class="activity-img" src="@/assets/product/digitalSystem/activity-banner-2.png" alt="">
              <div class="activity-content-left mg-left-50">
                <div class="title">去库存，商品配提 搭配销售高效去库存</div>
                <div class="multi-price-strategy-desc">
                  <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                  <div class="multi-price-strategy-desc-text" style="width: auto;">稀缺商品可进行搭售，快速去库存</div>
                </div>
                <div class="multi-price-strategy-desc">
                  <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                  <div class="multi-price-strategy-desc-text" style="width: auto;">搭售商品可按品牌、品类、单品进行配置</div>
                </div>
                <div class="multi-price-strategy-desc">
                  <img class="multi-price-strategy-desc-icon" :src="simpleCanceImg" alt="">
                  <div class="multi-price-strategy-desc-text" style="width: auto;">支持对搭售商品种类、数量、价格单独配置</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 供求信息一站式对接 -->
      <div class="One-Stop bg-color-E4EFFF" :style="{ backgroundImage: `url(${OneStopBannerImg})` }">
        <ModuleTitle data-aos="fade-up" :titleStype="{ marginBottom: '40px'}" title="供求信息一站式对接" :moduleTipsList="[{name: '采购商发布采购需求，供应商进行报价，供应商发布供应信息，采购商进行询价'}]" />
        <img class="img" data-aos="fade-up" src="@/assets/product/digitalSystem/One-Stop-2.png" alt="">
      </div>
      <div class="Underlay center-box bg-color-0A1447">
        <div class="max-width-1920" style="background-color: #0A1447;">
          <ModuleTitle  :titleStype="{ marginBottom: '40px'}" titleColor="#fff" :descStype="{ color: '#fff', opacity: 0.7 }" title="用户属性+全触点数字行为，构建360°用户统一视图" :moduleTipsList="[{name: '以用户为中心进行数据分析，针对性的制定销售策略，维系客户关系、促进销售增长'}]" />
          <img class="img" data-aos="fade-up" src="@/assets/product/digitalSystem/Underlay-2.png" alt="">
        </div>
      </div>
      <Footer/>
    </div>
</template>
<script>
import Banner from '@/assets/product/digitalSystem/banner.jpg'
import BusinessCharacteristics from '@/assets/product/digitalSystem/business-characteristics.png'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import DSUpModule from './components/dsUpModule.vue'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import SimpleCance from '@/assets/home/check.svg'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
export default {
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    ModuleBgBlue,
    DSUpModule
  },
   data() {
      return {
        OneStopBannerImg: OneStopBanner,
        simpleCanceImg: SimpleCance,
        CancelImg: Cancel,
        BannerImg: Banner,
        BusinessCharacteristicsImg: BusinessCharacteristics,
        title2: "S2B2b/B2B2b/B2b全链路数字化交易系统",
        titleRow1: '支持品牌垂直经营、POP入驻、',
        titleRow2: '经销商自营等',
        blueText: '多模式开展业务',
        titleTipsList: [
          {
            name: '产业链全链路端到端交易在线'
          },
          {
            name: '产业链角色全场景智能化决策'
          },
          {
            name: '打造品牌传统渠道的数字化经营与管理'
          },
          {
            name: '采用领先的springMVC+微服务架构'
          }
        ],
        moduleTipsList: [
          {
            name: '企业交易中的常见痛点'
          }
        ],
        painList: [
          {
            icon: require("@/assets/product/svgIcon/pain-spot-1.svg"),
            name: '线下沟通',
            imgShow: false,
            descList: [
              '电话或微信沟通，产品信息多，型号容易出错，发错货品',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-2.svg"),
            name: '库存积压',
            imgShow: false,
            descList: [
              '传统经销商要大量压货，确保型号齐全满足客户要求',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-3.svg"),
            name: '对接流程繁琐',
            imgShow: false,
            descList: [
              '客户大量询单，需要专人对接，频繁查询价格和库存，客户缺乏体验感',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-4.svg"),
            name: '渠道管控',
            imgShow: false,
            descList: [
              '强渠道管控逻辑，渠道价格及销售政策差异性大，严控渠道串货',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-5.svg"),
            name: '线下转账繁琐',
            imgShow: false,
            descList: [
              '线下大额转账繁琐，需要专人对接核对，人工认领核对工作量较大',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-6.svg"),
            name: '客户价值分析缺失',
            imgShow: false,
            descList: [
              '缺少客户的价值体系分析，数据不完整，无法进行有效的决策',
            ]
          }
        ],
        titleDescStype: {
          color: '#fff',
          opacity: 0.7
        },
        ModuleTitleStype: {
          marginBottom: '40px'
        },
        advantageCardStyle: {
          backgroundColor: '#fff',
          height: '250px'
        },
        advantageList: [
          {
            icon: require("@/assets/product/svgIcon/core-advantages-1.svg"),
            name: '多层级授权体系',
            imgShow: true,
            descList: [
              '交易通路全覆盖，支持不同类型客户的封闭及开放交易',
              '更好地管理其供应链，优化客户关系',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-2.svg"),
            name: '多模式经营',
            imgShow: true,
            descList: [
              '自营模式、pop模式、品牌垂直直营',
              '在不同市场环境和客户需求下可持续发展',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-3.svg"),
            name: '多段交易在线',
            imgShow: true,
            descList: [
              '各段交易全流程在线闭环，具备完整交易记录和数据追踪',
              'B2F集单反采,快速收集订单智能排产，提高产能利用率',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-4.svg"),
            name: '品类授权体系+价格管控',
            imgShow: true,
            descList: [
              '满足品牌分品类授权和区域管控要求',
              '具备多种价格管理方式，如区域价、阶梯价、会员价等',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-5.svg"),
            name: '营销政策',
            imgShow: true,
            descList: [
              '灵活的分销管理政策机制的制定,如返利政策、配货策略、配额管理等',
              '具备行业特点的运营策略，如竞价销售、行情分析',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-6.svg"),
            name: '360度用户画像',
            imgShow: true,
            descList: [
              '以数据为业务决策依据，服务客户差异化销售策略',
              '收集、分析客户在线行为，实现客户的全生命周期管理及随时触达',
            ]
          }
        ]
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.center-box {
  display: flex;
  justify-content: center;
}
.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}
.page-box {
  background-color: #fff;
}
.page-content {
  margin-bottom: 70px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 100px;
}
.showImg {
  width: 100%;
  height: auto;
  margin-bottom: 100px;
}
.core-advantages {
  padding: 71px 0 0 0;
}
.mg-btm-70 {
  margin-bottom: 70px;
}
.mg-btm-40 {
  margin-bottom: 40px;
}
.multi-mode {
  width: 100%;
  height: 700px;
  margin-bottom: 70px;
}
.multi-mode-item {
  width: 380px;
  height: 410px;
  text-align: left;
  position: relative;
  background: #fff;
  border-radius: 6px;
}
.mask-layer {
  position: absolute;
  top: 220px;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient( 180deg, rgba(255,255,255,0.6) 0%, #FFFFFF 100%);
}
.multi-mode-item-img {
  width: 380px;
  height: 240px;
  overflow: hidden;
  margin-bottom: 12px;
}
.multi-mode-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 21px;
  padding: 0px 30px;
}
.multi-mode-item-desc {
  font-size: 14px;
  color: #222222;
  line-height: 22px;
  padding: 0px 30px;
}
/* 商品管理 */
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.item-ilne-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
}
.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.item-ilne-content {
  width: 220px;
}
.goods-manage-mid-img {
  width: 600px;
  height: 480px;
}
.goods-manage-item {
  box-sizing: border-box;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 53px 0;
}
/* 多种价格策略 */
.multi-price-strategy {
  width: 100%;
  height: 660px;
  margin-bottom: 70px;
}
.multi-price-strategy-flex {
  display: flex;
}
.multi-price-strategy-flex .img {
  width: 667px;
  height: 360px;
  margin-right: 100px;
}
.multi-price-strategy-content {
  text-align: left;
}
.multi-price-strategy-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 10px;
}
.multi-price-strategy-item {
  margin-bottom: 50px;
}
.multi-price-strategy-desc {
  display: flex;
  margin-bottom: 20px;
}
.multi-price-strategy-desc-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  margin-top: 3px;
}
.multi-price-strategy-desc-text {
  width: 322px;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
/* 配额/配提灵活应用，促活跃去库存 */
.activity-box {
  width: 100%;
  height: 830px;
  padding-top: 70px;
}
.activity-content {
  text-align: left;
}
.activity-content .activity-content-item {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 100px;
}
.activity-content .activity-content-item .activity-content-left .title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 20px;
}
.activity-img {
  width: 640px;
  height: 200px;
}
.mg-right-115 {
  margin-right: 115px;
}
.mg-left-50 {
  margin-left: 50px;
}
/* 供求信息一站式对接 */
.One-Stop {
  height: 740px;
  width: 100%;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  padding-top: 70px;
}
.One-Stop .img {
  width: 1200px;
  height: 506px;
}
/* 用户属性+全触点数字行为，构建360°用户统一视图 */
.Underlay {
  width: 100%;
  height: 950px;
}
.Underlay .img {
  width: 1200px;
  height: 670px;
}
</style>
